// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"88008e32","918":"219752d4"}[chunkId] + ".chunk.js";
};